import React, { Component } from 'react';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Cookies } from 'react-cookie';
import styles from './ControlledEditor.css';
import APIService from '../../../services/api';
import PropTypes from 'prop-types';
import { FlatButton } from 'material-ui';
import withTranslation from '../../../hoc/withTranslation';

const cookies = new Cookies();

// Resolves with { data: { link } }, the format expected by react-draft-wysiwyg
function uploadImageCallBack(file) {
    return APIService.postDescriptionMedia(file, cookies.get('token'));
}

export class ControlledEditor extends Component {

    static propTypes = {
        initialValue: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.stateForValue(props.initialValue),
            view: 0,
        };
    }

    stateForValue = (value) => {
        let draft = htmlToDraft(value
            ? value
            : '');

        if (draft) {
            let contentState = ContentState.createFromBlockArray(draft.contentBlocks,
                draft.entityMap,
            );
            return {
                value: value,
                editorState: EditorState.createWithContent(contentState),
            };
        } else {
            return {
                value: value,
                editorState: EditorState.createEmpty(),
            };
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.input.value === nextProps.initialValue) {
            const state = this.stateForValue(nextProps.initialValue);
            this.setState(state);
        }
    }

    stateToHtml = (editorState) => {
        const context = editorState.getCurrentContent();
        const raw = convertToRaw(context);
        return draftToHtml(raw);
    };

    onEditorStateChange = (editorState) => {
        const value = this.stateToHtml(editorState);
        // Editor
        this.setState({
            editorState: editorState,
            value: value,
        });

        // Redux Form
        this.props.input.onChange(value);
    };

    onTextAreaChange = (event) => {
        event.stopPropagation();
        event.preventDefault();
        this.setState(this.stateForValue(event.target.value));
        this.props.input.onChange(event.target.value);
    };

    switchView = () => {
        if (this.state.view === 0) {
            this.setState({ view: 1 });
        } else {
            this.setState({ view: 0 });
        }
    };

    render() {
        const { editorState } = this.state;
        const onError = this.props.meta && this.props.meta.touched && this.props.meta.error;
        return (
            <div style={styles.field}>
                <label style={styles.span}>{this.props.label}</label>
                <div style={{...styles.editor, display: (this.state.view === 0) ? 'block' : 'none'}}>
                    <Editor
                        editorState={editorState}
                        wrapperClassName="wrapper"
                        editorClassName="editor"
                        onEditorStateChange={this.onEditorStateChange}
                        toolbar={{
                            inline: { inDropdown: true },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: { inDropdown: true },
                            history: { inDropdown: true },
                            image: { uploadCallback: uploadImageCallBack },
                            fontFamily: {
                                options: ['Arial', 'Georgia', 'Impact', 'Roboto', 'Tahoma', 'Times New Roman', 'Verdana'],
                                defaultFontFamily: 'Roboto',
                            },
                        }}
                        uploadEnabled
                        error
                    />
                </div>
                <textarea
                    value={this.state.value}
                    style={{...styles.textArea, display: (this.state.view === 1) ? 'block' : 'none'}}
                    onChange={this.onTextAreaChange}
                    rows={8}
                />
                <FlatButton
                    label={this.props.t((this.state.view === 0)
                        ? "form.switch_view_to_html"
                        : "form.switch_view_to_wysiwyg"
                    )}
                    onClick={this.switchView}
                />
                {onError && <p
                    style={{
                        position: 'relative',
                        bottom: '10px',
                        fontSize: '12px',
                        lineHeight: '12px',
                        color: 'rgb(244, 67, 54)',
                    }}
                >
                    {this.props.meta.error}
                </p>}
            </div>
        );
    }
}

export default withTranslation(ControlledEditor);



// WEBPACK FOOTER //
// src/components/form/ControlledEditor/ControlledEditor.js